/*
* show Spacing Y dropdown based on tab route or v-scored
*/
import React from 'react'
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'immutable-prop-types';
import SelectComponent from 'pu-react/components/SelectComponent';
import {
  arraySpacingY as tooltipVScore,
  arraySpacingXTabRouted as tooltipTabRouted,
} from 'pu-data/Tooltips';
import { spacingTabRouted, spacingVScored } from 'pu-data/SelectOptions'

const SpacingY = (props) => {
  const {parameters} = props;
  const selectedName = parameters.tab_rout === '1' ? 'array_spacing_y_tab_rout' : 'array_spacing_y_vscore'
  const onChange = e => props.onChangeParameter(selectedName, e.target.value);

  const spacingYTabRouted = (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={spacingTabRouted}
      tooltip={tooltipTabRouted}
      selected={parameters[selectedName] || ''}
      groupName={props.groupName} />)
  const spacingYVscore = (
    <SelectComponent
      label={props.label}
      required={props.required}
      name={props.name}
      onChange={props.onChange || onChange}
      options={spacingVScored}
      tooltip={tooltipVScore}
      selected={parameters[selectedName] || ''}
      groupName={props.groupName} />)
  const Component = parameters.tab_rout === '1' ? spacingYTabRouted : spacingYVscore
  return (<div>{Component}</div>)
};

SpacingY.defaultProps = {
  label   : 'Spacing in Y',
  name    : 'array_spacing_y',
  required: true,
  onChange: null,
};

// SpacingY.propTypes = {
//   label            : PropTypes.string,
//   name             : PropTypes.string,
//   required         : PropTypes.bool,
//   onChange         : PropTypes.func,
//   parameters       : ImmutablePropTypes.map.isRequired,
//   onChangeParameter: PropTypes.func.isRequired,
// }

export default SpacingY;
